import styled from "styled-components";
import {Title2} from "../../../styles/components";

export const Container = styled.div`
  width: 100%;
  height: 400px;
  margin: 20vh 0;
  padding: 0 3vw;
  color: ${({theme}) => theme.colors.black};

  @media only screen and (${({theme}) => theme.media.extraLarge}) {
    padding: 0 12%;
  }
`

export const Content = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0 100px;
`

export const TextBlock = styled.div`
  width: 50%;
  height: 100%;
`

export const Title = styled(Title2)`
  margin-bottom: 20px;
`

export const Image = styled.img`
  width: auto;
  height: 80%;
`

export const Help = styled.div`
  color: ${({theme}) => theme.colors.red};
  font-family: ${({theme}) => theme.font.family};
  font-size: 22px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin: 40px 0;
`

export const ModalBody = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2rem;
  padding: 0;

  @media only screen and (${({theme}) => theme.media.small}) {
    padding: 2rem 0;
    gap: 4rem;
  }
  
  @media only screen and (${({theme}) => theme.media.medium}) {
    gap: 4rem;
  }
`

export const QRCode = styled.img`
  width: 70%;
  height: auto;
  text-align: center;
`

export const ModalText = styled.div`
  text-align: center;
  font-size: 12px;
  color: ${({theme}) => theme.colors.red};

  @media only screen and (${({theme}) => theme.media.small}) {
    font-size: 18px;
  }
  
  @media only screen and (${({theme}) => theme.media.medium}) {
    font-size: 25px;
  }
  
  @media only screen and (${({theme}) => theme.media.large}) {
    font-size: 30px;
  }
`